/*!
 * [Betbuilder Aggregator API] Texty
 */

// Inicializácia textov - zavolá sa až keď sú načítané preklady
betbuilderAgg.initTexts = function() {
    if (typeof texts === 'undefined') {
        console.warn('[BetBuilder Agg] Texts not available yet');
        return;
    }
    betbuilderAgg.texts = {
        BetBuilderAggLoadError: texts.BetBuilderAggLoadError || "Nepodarilo sa načítať BetBuilder príležitosti",
        BetBuilderAggMaxOdds: texts.BetBuilderAggMaxOdds || "Maximálny počet kombinácií je 10",
        BetBuilderAggMinOdds: texts.BetBuilderAggMinOdds || "Vyberte aspoň 2 príležitosti",
        BetBuilderAggAddToTicket: texts.BetBuilderAggAddToTicket || "Pridať na tiket",
        BetBuilderAggTotalRate: texts.BetBuilderAggTotalRate || "Celkový kurz",
        BetBuilderAggAddError: texts.BetBuilderAggAddError || "Nepodarilo sa pridať na tiket",
        BetBuilderAggConflictMessageHeader: texts.BetBuilderAggConflictMessageHeader || "Táto kombinácia nie je možná",
        BetBuilderAggConflictMessageText: texts.BetBuilderAggConflictMessageText || "Daná príležitosť sa nedá kombinovať s už vybratými príležitosťami.",
        BetBuilderAggConflictButton: texts.BetBuilderAggConflictButton || "OK",
        BetBuilderAggSelectionModalTitle: texts.BetBuilderAggSelectionModalTitle || "Betbuilder výber",
        BetBuilderAggToggleSelection: texts.BetBuilderAggToggleSelection || "Vybrané príležitosti",
        BetBuilderAggSuspendedMessage: texts.BetBuilderAggSuspendedMessage || "Betbuilder kombinácia je dočasne pozastavená",
        BetBuilderAggClosedMessage: texts.BetBuilderAggClosedMessage || "Betbuilder kombinácia bola uzavretá",
        BetBuilderAggNoOpportunitiesMessage: texts.BetBuilderAggNoOpportunitiesMessage || "Momentálne nie sú pre tento zápas dostupné žiadne príležitosti",
        BetBuilderAggNoSelectedOdds: texts.BetBuilderAggNoSelectedOdds || "Nemáte vybraté žiadne príležitosti Betbuildera.",
        BetBuilderAggSingleOddMessage: texts.BetBuilderAggSingleOddMessage || "Pre BetBuilder stávku pridaj ďalší tip."
    };
};
